import React from "react";
import * as S from "./styles";

interface IBadgeProps {
	isAbsolute?: boolean;
	colorBadge?: string;
	content: string | number | React.ReactNode;
}

function KOGBadge({ content, colorBadge, isAbsolute = false }: IBadgeProps) {
	return (
		<S.Container colorBadge={colorBadge} isAbsolute={isAbsolute}>
			{content}
		</S.Container>
	);
}

export default KOGBadge;
